module.exports = __webpack_public_path__ + "img/hero_md.fc88f387.png";